module.exports = ".custom-control {\r\n  display: inline-block;\r\n  margin-right: 20px;\r\n}\r\n\r\ntextarea {\r\n  height: 200px;\r\n  resize: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/email-to/email-to.component.css
// module id = ./src/app/shared/components/email-to/email-to.component.css
// module chunks = main